import { render, staticRenderFns } from "./Create-Or-Update-Notification.vue?vue&type=template&id=7e35a13e"
import script from "./Create-Or-Update-Notification.vue?vue&type=script&lang=js"
export * from "./Create-Or-Update-Notification.vue?vue&type=script&lang=js"
import style0 from "./Create-Or-Update-Notification.vue?vue&type=style&index=0&id=7e35a13e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports